var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"!rounded-full border-current border-l-transparent border-t-transparent inline-block align-middle pointer-events-none animate-spin",class:_vm.waiting ? 'waiting' : '',style:(_vm.sizeStyles)})
}
var staticRenderFns = []

export { render, staticRenderFns }